import aarhusguidenConstructCard from "./aarhusguiden-construct-card";

export function aarhusguidenList(){
    if(document.querySelector('.js-aarhusguiden--list')){
        document.querySelectorAll('.js-aarhusguiden--list').forEach((element) => {
            const currentTime = new Date();
            const dateString = currentTime.toISOString().substring(0, 11) + '00:00:00+00:00';

            //const element = document.querySelector('.js-aarhusguiden--list');
            const currentUrl = window.location.origin;
            const baseUrl = 'https://api.detskeriaarhus.dk/api/v2/daily_occurrences'
            const baseUrlHighlight = 'https://api.detskeriaarhus.dk/api/v2/occurrences'
            const accessToken = 'iw1pvLnjtBM0AvNG7TeH7ZT4ukNYgpdAWxUZ96Rc';

            //- Collect fetch params from DOM
            let numberParam = element.dataset.number ? `&itemsPerPage=${element.dataset.number}` : '&itemsPerPage=3';
            const tagsParam = element.dataset.tags ? `&event.tags=${encodeURIComponent(element.dataset.tags)}` : '';
            const accessParam = element.dataset.access ? `&event.publicAccess=${element.dataset.access}` : '';
            //const postalcodeParam = element.dataset.postalcode ? element.dataset.postalcode : '';
            const locationParam = element.dataset.location ? `&event.location.entityId=${encodeURIComponent(element.dataset.location)}` : '';
            const organizerParam = element.dataset.organizer ? `&event.organizer.entityId=${encodeURIComponent(element.dataset.organizer)}` : '';
            const startParam = `&start=${encodeURIComponent(dateString)}`

            const dataUrl = element.dataset.url ? element.dataset.url : '';
            //- Fetch resource
            let url = baseUrl + '?page=1' + numberParam + tagsParam + accessParam + locationParam + organizerParam + startParam;
            const row = element.querySelector('.row--grid')
            
            //- Fetch highlight card if applicable
            if(element.getAttribute('data-highlight')){
                const highlightUrl = baseUrlHighlight + '/' + element.getAttribute('data-highlight');
                //- Fetch one less normal card
                numberParam = element.dataset.number ? `&itemsPerPage=${element.dataset.number - 1}` : '&itemsPerPage=2'

                async function fetchHighlight(){
                    const response = await fetch(highlightUrl, {
                        headers: {
                            'Origin': currentUrl,
                            'X-Api-Key': accessToken
                        }
                    });
                    const highlight = await response.json();
                    aarhusguidenConstructCard(highlight['hydra:member'][0], row, dataUrl);

                    url = baseUrl + '?page=1' + numberParam + tagsParam + accessParam + locationParam + organizerParam + startParam;
                    fetchEvents()
                }
                fetchHighlight()
            } else {
                fetchEvents()
            }
            


            async function fetchEvents(){
                const response = await fetch(url, {
                    headers: {
                        'Origin': currentUrl,
                        'X-Api-Key': accessToken
                    }
                });
                const events = await response.json()
                //Construct cards of each returned event
                events['hydra:member'].forEach((event) => {
                    aarhusguidenConstructCard(event, row, dataUrl)
                })
            }
    
            //-fetchEvents()
        })
    }




}

export default aarhusguidenList;
